import type { FaireProductEntity } from "../../entity_types/product";

export const p_m2j4zpv33w: FaireProductEntity = {
  token: "p_m2j4zpv33w",
  type: "product",
  name: "WEEKEND LOVER SCENTED CANDLE",
  brandToken: "b_s4mtr37bpt",
  brandName: "Hazeltine Scent Company",
  imageUrl:
    "https://cdn.faire.com/fastly/e862af7bc8010cc0a3685d13c04962f47b93a6c544e33bed55310c8969bde4c7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a6139af88fa3737214efc632203483b3dc0e56ac56dedf69f7a958baa35a3af5.jpeg",
  ],
  priceDollars: 27,
  description:
    "Weekend Lover is an ode and tribute to the late artist Prince. At once crisp and sultry, this scent blends fresh lavender and rain with exotic woods and warm, resinous amber. It is purple velvet in scent form and—we hope—a fitting homage to the musical genius and sensual fantasy man himself. \n\nTop notes: pink peppercorn\nHeart notes: lavender, rain\nBase notes: patchouli, agarwood, amber\n\n * 9 ounces / 255 grams \n * approximately 40 hours of burn time \n * coconut wax ",
  tags: [],
  msrpDollars: 54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:56.683Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
